import { criterionScores } from './criterionScores.js';
import { axes } from './axes.js';
import { momentum } from './momentum.js';

const LO = 45;
const HI = 55;

function bandHL(v100, mom) {
  if (v100 < LO) return false;       // low
  if (v100 > HI) return true;        // high
  return mom >= 3.0;                 // neutral band tie-break
}

export function classify({ answers, boughtTools, selfId, expFollowup }) {
  const c = criterionScores(answers);
  const ax = axes(c);
  const mom = momentum(answers);
  const hiD = bandHL(ax.direction100, mom);
  const hiR = bandHL(ax.readiness100, mom);

  let base;
  if (hiD && hiR) base = mom >= 3.5 ? "scaler" : "primed";
  else if (hiD && !hiR) base = "experimenter";
  else if (!hiD && hiR) base = "quiet";
  else base = "evaluator";

  // Stalled Buyer override
  if (base === "experimenter" && boughtTools && (answers.C1 || 0) <= 2) {
    base = "stalled";
  }

  // Regrouper posture
  let posture = null;
  let postureSource = null;
  if (selfId === "regrouper") {
    posture = "regrouper";
    postureSource = "self";
  } else if (hiD && mom < (c.capability - 0.5)) {
    posture = "regrouper";
    postureSource = "inferred";
  }

  // Capacity gate
  let flag = null;
  const gradeMean = Object.values(c).reduce((a, b) => a + b, 0) / Object.keys(c).length;
  if ((answers.CP1 || 0) <= 2) {
    flag = "blocked";
  } else if ((answers.CP1 || 0) === 5 && gradeMean < 3) {
    flag = "untapped";
  }

  // self-ID reconciliation note
  let reconcile = null;
  if (selfId && selfId !== "none" && selfId !== base && !(posture && selfId === "regrouper")) {
    reconcile = { selfId, diagnostic: base };
  }

  const grade =
    gradeMean < 2 ? 1 : gradeMean < 2.8 ? 2 : gradeMean < 3.6 ? 3 : gradeMean < 4.3 ? 4 : 5;
  const gradeName = ["", "Nascent", "Emerging", "Developing", "Established", "Advanced"][grade];

  return {
    c,
    ax,
    mom,
    base,
    posture,
    postureSource,
    flag,
    reconcile,
    gradeMean,
    grade,
    gradeName
  };
}
